export const esEs = {
  translation: {
    floatingButton: {
      suggestion: "sugerencia",
      suggestions: "sugerencias",
      notification: {
        close: "Cerrar",
        draggable: "Arrastrar",
      },
    },
    sidebar: {
      header: {
        title: "BIA Agents",
        salesTitle: "Sugerencias de ventas",
      },
      tabs: {
        chat: "Chat",
        historico: "Historial",
        sales: "Sales Agents",
      },
      suggestions: {
        title: "Sugerencias basadas en su pedido",
        description: "Los clientes que compran artículos en su pedido también tienden a comprar:",
        loading: "Cargando sugerencias...",
        empty: "Sin sugerencias disponibles",
        code: "Código",
        addButton: "Añadir",
        price: "€",
      },
      repeatOrder: {
        title: "Repetir Pedido",
        empty: "No se encontraron pedidos",
        lastPurchase: "Última compra del cliente el",
        order: "El pedido",
        orderItems: "contiene los siguientes artículos:",
        selectAll: "Seleccionar todo",
        totalOrder: "Total del pedido:",
        repeatButton: "Repetir pedido",
        itemQuantity: "unidad(es) |",
        each: "cada",
      },
      chat: {
        placeholder: "💬 El contenido del chat se mostrará aquí",
      },
      history: {
        placeholder: "📋 El historial de pedidos se mostrará aquí",
      },
      close: "Cerrar",
    },
    errors: {
      loadSuggestions: "Error al cargar sugerencias:",
      invalidMovementType: "El tipo de movimiento no está permitido para sugerencias:",
      paramsBuildCarrinhoNotInitialized: "paramsBuildCarrinho no está inicializado para el contexto CART",
      floatingButtonPosition: "Error al cargar la posición del botón flotante:",
      floatingButtonSavePosition: "Error al guardar la posición del botón flotante:",
    },
    logs: {
      suggestionsLoaded: "sugerencias cargadas desde la API",
    },
  },
};
